import shortenNumber from '../utils/shortenNumber';
export function limitNumber(number) {
    return number > 999 ? shortenNumber(number, 0, Math.floor) : "" + number;
}
//# sourceMappingURL=helpers.js.map